import { render, staticRenderFns } from "./GroupMobileReserved.vue?vue&type=template&id=22017654"
import script from "./GroupMobileReserved.vue?vue&type=script&lang=js"
export * from "./GroupMobileReserved.vue?vue&type=script&lang=js"
import style0 from "./GroupMobileReserved.vue?vue&type=style&index=0&id=22017654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports